import { ref, computed } from 'vue';
export const usePointOutCounter = () => {
    // lintの指摘の数
    const lintErrorPointCounter = ref(0);
    // lintの指摘の数を更新
    const updateLintErrorPointCounter = (count) => {
        lintErrorPointCounter.value = count;
    };
    // lintの指摘の数をインクリメント
    const inncrementLintErrorPointCounter = () => {
        lintErrorPointCounter.value++;
    };
    // lintの指摘の数をデクリメント
    const decrementLintErrorPointCounter = () => {
        lintErrorPointCounter.value--;
    };
    // gptの指摘の数
    const gptErrorPointCounter = ref(0);
    // gptの指摘の数を更新
    const updateGptErrorPointCounter = (count) => {
        gptErrorPointCounter.value = count;
    };
    // gptの指摘の数をインクリメント
    const inncrementGptErrorPointCounter = () => {
        gptErrorPointCounter.value++;
    };
    // gptの指摘の数をデクリメント
    const decrementGptErrorPointCounter = () => {
        gptErrorPointCounter.value--;
    };
    //　校正+gptの指摘の数
    const totalErrorPointCounter = computed(() => {
        return lintErrorPointCounter.value + gptErrorPointCounter.value;
    });
    const resetErrorPointCounter = () => {
        lintErrorPointCounter.value = 0;
        gptErrorPointCounter.value = 0;
    };
    return {
        lintErrorPointCounter,
        updateLintErrorPointCounter,
        decrementLintErrorPointCounter,
        gptErrorPointCounter,
        updateGptErrorPointCounter,
        totalErrorPointCounter,
        resetErrorPointCounter
    };
};
